import React from 'react';
import { useForm } from 'react-hook-form';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { Button } from 'primereact/button';

import FormInputText from '../../components/form/FormInputText';
import { IntegrationSettings } from '../../models/integrationSettings';
import { IntegrationStatus, IntegrationVendor } from '../../models/enums/integrationEnums';
import { parseIntegrationData } from '../../utils/misc-utils';

type RatesBoardFormValues = {
  branchCode: string;
};

interface EditRatesBoardPricingIntegrationSettingsProps {
  onCancel: () => void;
  onSave?: (settings: IntegrationSettings) => void;
  integrationSettings?: IntegrationSettings;
  environment: string;
}

export const EditRatesBoardPricingIntegrationSettings = ({
  onCancel,
  onSave,
  integrationSettings,
  environment,
}: EditRatesBoardPricingIntegrationSettingsProps): JSX.Element => {
  const isEditMode = !!integrationSettings;

  let branchCode = '';
  if (isEditMode && integrationSettings?.integrationData) {
    const data = parseIntegrationData(integrationSettings.integrationData);
    branchCode = data.branchCode || '';
  }

  const validationSchema = yup.object().shape({
    branchCode: yup.string().required('Branch Code is required'),
  });

  const { control, handleSubmit, formState } = useForm<RatesBoardFormValues>({
    defaultValues: {
      branchCode: branchCode,
    },
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });

  const { errors } = formState;

  const onSubmit = (data: RatesBoardFormValues) => {
    console.log('Form validated successfully:', data);

    if (onSave) {
      let settings: IntegrationSettings;

      if (isEditMode && integrationSettings) {
        settings = {
          ...integrationSettings,
          environment: environment,
          integrationData: JSON.stringify({
            branchCode: data.branchCode,
          }),
        };
      } else {
        settings = {
          name: 'RatesBoard Pricing Integration',
          vendor: IntegrationVendor.RatesBoard,
          status: IntegrationStatus.Active,
          environment: environment,
          integrationData: JSON.stringify({
            branchCode: data.branchCode,
          }),
        };
      }

      onSave(settings);
    }
  };

  return (
    <div className="surface-section p-4 border-1 surface-border border-round mb-3">
      <h3 className="mt-0 mb-3">{isEditMode ? 'Edit RatesBoard Pricing Settings' : 'RatesBoard Pricing Settings'}</h3>
      <form onSubmit={handleSubmit(onSubmit)} noValidate className="pb-3 p-fluid p-input-filled">
        <div className="field mb-4">
          <FormInputText
            control={control}
            errors={errors}
            field="branchCode"
            label="Branch Code*"
            placeholder="Enter your RatesBoard Branch Code"
          />
        </div>

        <div className="flex justify-content-end gap-2 pt-4">
          <Button
            type="button"
            label="Cancel"
            className="p-button-outlined"
            style={{ width: 'auto', minWidth: 'auto' }}
            onClick={onCancel}
          />
          <Button
            type="submit"
            label={isEditMode ? 'Update' : 'Save'}
            className="p-button"
            style={{ width: 'auto', minWidth: 'auto' }}
          />
        </div>
      </form>
    </div>
  );
};
